import { GetLocaleTextParams, GridOptions, RowSelectionOptions } from '@ag-grid-community/core';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { ServerSideRowModelModule } from '@ag-grid-enterprise/server-side-row-model';
import { ClipboardModule } from '@ag-grid-enterprise/clipboard';
import { RangeSelectionModule } from '@ag-grid-enterprise/range-selection';
import { CsvExportModule } from '@ag-grid-community/csv-export';
import { MenuModule } from '@ag-grid-enterprise/menu';
import { ExcelExportModule } from '@ag-grid-enterprise/excel-export';

import ascIcon from '../svg/md/outline-arrow_upward-24px.svg';
import descIcon from '../svg/md/outline-arrow_downward-24px.svg';
import menuIcon from '../svg/md/outline-menu-24px.svg';
import mdFilterIcon from '../svg/md/filter_list-24px.svg';
import { TranslationService } from '../services/translation.service';

import { LoadingSpinnerCellComponent } from './cell-renderers/loading-spinner-cell.component';
import { CommonColDef } from './column-defs';

const TRANSLATED_AG_GRID_TERMS = new Set([
	'copy',
	'copyWithHeaders',
	'paste',
	'export',
	'csvExport',
	'excelExport',
	'excelXmlExport'
]);
export class CommonGridOptions<TData = unknown> implements GridOptions<TData> {
	translationService!: TranslationService;
	headerHeight = 44;
	rowHeight = 32;
	rowSelection: RowSelectionOptions<TData> | 'multiple' | 'single' | undefined = 'multiple';
	suppressRowClickSelection = true;
	cellSelection = true;
	enableBrowserTooltips = true;
	suppressPropertyNamesCheck = true;
	loadingCellRenderer = LoadingSpinnerCellComponent;
	icons = {
		sortAscending: ascIcon,
		sortDescending: descIcon,
		menu: menuIcon,
		filter: mdFilterIcon,
	};

	defaultColDef = new CommonColDef<TData>();
	ensureDomOrder = true;

	columnMenu = <const> 'legacy';

	constructor(params: GridOptions & { translationService: TranslationService }) {
		Object.assign(this, params);
	}

	getLocaleText = (params: GetLocaleTextParams) => {
		if (TRANSLATED_AG_GRID_TERMS.has(params.key)) {
			return this.translationService.getTR(`ag-grid.${ params.key }`);
		}
		return params.defaultValue;
	};
}

export const clientSideAgGridModules = [
	ClientSideRowModelModule,
	CsvExportModule,
	ClipboardModule,
	RangeSelectionModule,
	MenuModule
];
export const serverSideAgGridModules = [
	ServerSideRowModelModule,
	CsvExportModule,
	ExcelExportModule,
	ClipboardModule,
	RangeSelectionModule,
	MenuModule
];
